/**
 * Formats a per-unit reward RATE (e.g. $ per mile) — NOT a flat amount. Monetary rates render
 * in cents when under a dollar so distinct sub-cent rates stay distinct (0.008 → "0.8¢",
 * 0.0125 → "1.25¢"), and as dollars at/above $1. When the program doc provides units, append
 * the denominator (e.g. "1.25¢ / mile"). Shared by the reward heading's rate subtitle and the
 * override control's rate options so the two always agree.
 *
 * Flat / amount-based rewards are not rates — format those with the currency formatter instead.
 */
const formatRewardRate = ({
  rate,
  rewardType,
  units,
}: {
  rate: number;
  rewardType: 'none' | 'points' | 'monetary';
  units?: string;
}): string => {
  const unit = (() => {
    const trimmed = units?.trim();
    if (!trimmed || trimmed === '%') {
      return undefined;
    }
    if (trimmed.toLowerCase() === 'miles') {
      return 'mile';
    }
    return trimmed;
  })();

  const formattedRate =
    rewardType === 'monetary'
      ? rate < 1
        ? `${+(rate * 100).toFixed(2)}¢`
        : `$${+rate.toFixed(2)}`
      : `${rate}`;

  if (unit) {
    return `${formattedRate} / ${unit}`;
  }

  return formattedRate;
};

export default formatRewardRate;
